export default "__VITE_ASSET__a8cebf26__"